export default __webpack_public_path__ + "static/media/card1@2x.cd64d346.png";